"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _renders = _interopRequireDefault(require("../renders"));
var _RenderSettingsWrapper = _interopRequireDefault(require("./RenderSettingsWrapper.js"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _prettify = require("../prettify.js");
var _settings = require("../settings.js");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Fortress = window.cccisd.fortress;
var getCurrentRender = (0, _memoize2["default"])(function (handle) {
  return _renders["default"].find(function (item) {
    return item.handle === handle;
  });
});
var alignmentOptions = [{
  value: 'left',
  label: 'Left'
}, {
  value: 'center',
  label: 'Center'
}, {
  value: 'right',
  label: 'Right'
}];
var validate = function validate(values) {
  var errors = {};
  if (!values.isAction) {
    if (!values.query) {
      errors.query = 'Query is required';
    } else if (!(0, _prettify.isCorrectQuery)(values.query)) {
      errors.query = 'Wrong syntax or getting more than one field';
    }
  } else if (!values.render) {
    errors.render = 'Format is required';
  }
  if (values.render) {
    var currentRender = getCurrentRender(values.render);
    if (currentRender.validateSettings && !(0, _isEmpty2["default"])(currentRender.validateSettings(values.renderSettings))) {
      errors.renderSettings = 'There are some errors in format settings';
    }
  }
  if (values.showTopHeader) {
    if (!values.topHeader) {
      errors.topHeader = 'Top Header is required';
    }
  }
  return errors;
};
var EditColumnForm = function EditColumnForm(props) {
  var settings = props.settings,
    tableSettings = props.tableSettings;
  var renders = [{
    value: '',
    label: 'No format'
  }].concat(_toConsumableArray(_renders["default"].filter(function (item) {
    if (settings.isAction) {
      return item.isAction && (!item.applyToLevels || item.applyToLevels.includes(tableSettings.level));
    }
    return !item.isAction && (!item.applyToTypes || item.applyToTypes.includes(settings.type));
  }).map(function (item) {
    return {
      value: item.handle,
      label: item.label
    };
  })));
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: _objectSpread({
      renderSettings: {},
      topHeaderSpan: 2
    }, settings),
    onSubmit: function onSubmit(values) {
      props.onSubmit(values);
      props.closeModal();
    },
    validate: validate,
    render: function render(_ref) {
      var values = _ref.values,
        setValues = _ref.setValues,
        setFieldValue = _ref.setFieldValue,
        submitCount = _ref.submitCount;
      var currentRender = getCurrentRender(values.render);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "label",
        component: _cccisdFormik.CccisdInput,
        label: "Label"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "tooltip",
        component: _cccisdFormik.CccisdInput,
        label: "Tooltip"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Style"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "isBold",
        render: function render(_ref2) {
          var field = _ref2.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: field.onChange,
            checked: !!field.value
          }), ' ', "Bold value"));
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "noWrapHeader",
        render: function render(_ref3) {
          var field = _ref3.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: field.onChange,
            checked: !!field.value
          }), ' ', "No wrap header"));
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "noWrapValue",
        render: function render(_ref4) {
          var field = _ref4.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: field.onChange,
            checked: !!field.value
          }), ' ', "No wrap value"));
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Alignment"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "alignment",
        render: function render(_ref5) {
          var field = _ref5.field,
            form = _ref5.form;
          return /*#__PURE__*/_react["default"].createElement("div", null, alignmentOptions.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.value,
              className: "radio",
              style: {
                margin: 0
              }
            }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
              type: "radio",
              value: item.value,
              checked: field.value === item.value,
              onChange: function onChange() {
                return form.setFieldValue('alignment', item.value);
              }
            }), ' ', item.label));
          }));
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Show"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "hideInTable",
        render: function render(_ref6) {
          var field = _ref6.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: function onChange() {
              return setFieldValue('hideInTable', !field.value);
            },
            checked: !field.value
          }), ' ', "In table"));
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "hideInCsv",
        render: function render(_ref7) {
          var field = _ref7.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: function onChange() {
              return setFieldValue('hideInCsv', !field.value);
            },
            checked: !field.value
          }), ' ', "In CSV"));
        }
      })))), tableSettings.showTotal && ['number', 'int'].includes(values.type) && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "includeInTotal",
        component: _cccisdFormik.CccisdToggle,
        label: "include in total"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info",
        style: {
          paddingBottom: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "render",
        component: _cccisdFormik.CccisdSelect,
        label: "Format",
        options: renders,
        style: {
          width: 'auto'
        },
        onChange: function onChange(e) {
          var render = e.target.value;
          var renderInfo = _renders["default"].find(function (item) {
            return item.handle === render;
          });
          var renderSettings = renderInfo ? renderInfo.initialSettings : {};
          renderSettings.doNotTraverse = true;
          setValues(_objectSpread(_objectSpread({}, values), {}, {
            render: render,
            renderSettings: renderSettings
          }));
        }
      }), currentRender && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        key: values.render,
        name: "renderSettings",
        render: function render(_ref8) {
          var field = _ref8.field,
            form = _ref8.form;
          return /*#__PURE__*/_react["default"].createElement(_RenderSettingsWrapper["default"], {
            initialValues: values.renderSettings,
            render: currentRender,
            onChange: form.setFieldValue.bind(null, 'renderSettings'),
            showErrorsImmediately: submitCount > 0,
            columnSettings: values
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "showTopHeader",
        render: function render(_ref9) {
          var field = _ref9.field;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: _objectSpread({
              marginTop: 0
            }, values.showTopHeader ? {} : {
              marginBottom: 0
            })
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            name: field.name,
            onChange: field.onChange,
            checked: !!field.value
          }), ' ', "show top header"));
        }
      }), values.showTopHeader && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "topHeader",
        component: _cccisdFormik.CccisdInput,
        label: "Top header"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "topHeaderTooltip",
        component: _cccisdFormik.CccisdInput,
        label: "Tooltip"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "topHeaderSpan",
        component: _cccisdFormik.CccisdInput,
        label: "Span count",
        type: "number",
        min: 1,
        max: 100,
        style: {
          width: '4em'
        }
      })))), !settings.isAction && !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group",
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Advanced settings"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "query",
        component: _cccisdFormik.CccisdTextarea,
        label: "Query",
        style: {
          height: '10em'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Type:"), " ", (_settings.columnTypesMap[values.type] || {}).label))), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Submit"));
    }
  });
};
EditColumnForm.propTypes = {
  settings: _propTypes["default"].object,
  tableSettings: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func,
  closeModal: _propTypes["default"].func
};
EditColumnForm.defaultProps = {};
var _default = exports["default"] = EditColumnForm;